// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class U128 implements flatbuffers.IUnpackableObject<U128T> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):U128 {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsU128(bb:flatbuffers.ByteBuffer, obj?:U128):U128 {
  return (obj || new U128()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsU128(bb:flatbuffers.ByteBuffer, obj?:U128):U128 {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new U128()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

upper():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

lower():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

static startU128(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addUpper(builder:flatbuffers.Builder, upper:bigint) {
  builder.addFieldInt64(0, upper, BigInt('0'));
}

static addLower(builder:flatbuffers.Builder, lower:bigint) {
  builder.addFieldInt64(1, lower, BigInt('0'));
}

static endU128(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishU128Buffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset);
}

static finishSizePrefixedU128Buffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, undefined, true);
}

static createU128(builder:flatbuffers.Builder, upper:bigint, lower:bigint):flatbuffers.Offset {
  U128.startU128(builder);
  U128.addUpper(builder, upper);
  U128.addLower(builder, lower);
  return U128.endU128(builder);
}

unpack(): U128T {
  return new U128T(
    this.upper(),
    this.lower()
  );
}


unpackTo(_o: U128T): void {
  _o.upper = this.upper();
  _o.lower = this.lower();
}



unpackFields(...fields: string[]): U128T {
  const t = new U128T();
  const fieldSet = new Set(fields);
  if (fieldSet.has('upper')) {
    t.upper = this.upper();
  }
  if (fieldSet.has('lower')) {
    t.lower = this.lower();
  }
  return t;
}
}

export class U128T implements flatbuffers.IGeneratedObject {
constructor(
  public upper: bigint = BigInt('0'),
  public lower: bigint = BigInt('0')
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return U128.createU128(builder,
    this.upper,
    this.lower
  );
}

clone(): U128T {
  const obj = new U128T();
  obj.upper = this.upper;
  obj.lower = this.lower;
  return obj;
}

equals(other: U128T): boolean {
  if (this.upper !== other.upper) return false;
  if (this.lower !== other.lower) return false;
  return true;
}
}

export function verifyU128(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 8);
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsU128(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyU128(verifier, tablePos);
}
